import React, { useEffect, useMemo } from 'react'
import { ContainerField, Container } from '@sencha/ext-modern'

import { getMixedProps, genNewList } from './blockPublic'
import { useDelayTimer, useInstData } from 'tyan/public/hooks'

// const argsOfRender = { field, onChange, initValues, changedValues, defaultStyle, that, renderField }
const Group = ({ field, field: { _fieldsetName }, /* onChange,  */initValues, changedValues, defaultStyle, that, renderField }) => {
	const {
		props: { layout: layoutProp, initHeight, scrollable, delay, label, ...props },
		rest: { name, _group, forceDisabled, list: groupList, items, default: _default = {}, ...restGroup }
	} = getMixedProps('_group', [defaultStyle, field])

	const { me, me: { fieldID, height, state: { showMe } }, setState } = useInstData(
		undefined,
		useMemo(() => ({ fieldID: `group-${Tyan.getUuid()}`, height: initHeight, state: { showMe: false } }), [])
	)

	const layout = typeof layoutProp === 'string' ? { type: layoutProp } : layoutProp
	restGroup.disabled = props.disabled
	delete restGroup.value

	// console.log('newList:', groupList, field, defaultStyle)

	const { doDelay } = useDelayTimer(10)

	useEffect(() => {
		const { dom } = me
		const doShowMe = () => {
			!me.state.showMe && setState({ showMe: true })
			// Tyan.unobserveIO(dom)
		}

		const doHideMe = () => {
			const { height } = dom.getBoundingClientRect()
			me.height = height
			me.state.showMe && setState({ showMe: false })
		}

		if (delay) {
			Tyan.observeIO(dom, ({ isIntersecting }) => {
				isIntersecting ? doDelay(doShowMe) : doDelay(doHideMe)
			})

			return () => {
				Tyan.unobserveIO(dom)
			}
		} else
			doDelay(doShowMe)
	}, [])

	const renderContents = () => (
		items && items.map(({ list, ...item }, index) => renderField({
			field: { ...item, _fieldsetName, ...(forceDisabled ? { disabled: true } : {}), list: genNewList(list, groupList) },
			defaultStyle: { ...defaultStyle, ...restGroup, ..._default, forceDisabled/* maxWidth: 'calc(100% - 40px)' */ },
			initValues, changedValues, index, data: that
		})) || null
	)

	return label
		? <ContainerField id={`containerfield-${fieldID}`} {...props} label={label}
			ref={ref => ref && (me.dom = ref.cmp.el.dom)}
			{...showMe ? {} : { height }}
			layout='fit'
		>
			{showMe
				? <Container {...{ layout: { type: 'hbox', pack: 'start', wrap: true, ...layout }, scrollable, errorTarget: undefined }}>
					{renderContents()}
				</Container>
				: null
			}
		</ContainerField>
		: <Container id={`container-${fieldID}`} {...props}
			ref={ref => ref && (me.dom = ref.cmp.el.dom)}
			{...showMe ? {} : { height }}
			{...{ layout: { type: 'hbox', pack: 'start', wrap: true, ...layout }, scrollable, errorTarget: undefined }}
		>
			{showMe
				? renderContents()
				: null
			}
		</Container>

}

const renderGroup = config => {
	const { key } = config.field || {}
	return <Group key={key} {...config} />
}

export default renderGroup